module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAANCAQAAAAKsiavAAAAvElEQVQYGX3BPysEAAAH0DfcoHBl0JXoiuEWG2W+zWhUNpmUMlAMSEkWs391BsmkpCjKZjb4ChYpg25g8tMJ3dWd9/ypWHbizq1jC8paVN2LiIiIuDLmW7eaiFdnFk2bseRCXXzaUeBAvJjXpVnRqrpYY8iekoYJ62qOrBjVMOJQnx8V1yIiIk4NatLrXbw5t2nbpQ/xrMWsXf1+le2b0kbVlg3jOpgTETGprR4PIm4UdDDgyaOifwwrafEFVnw/gf0FogkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/wifi_icon.png
// module id = 186
// module chunks = 1